import { atom, selector } from 'recoil';
import { filteredInstructorIds } from './instructorState';

export const pinnedByInstructorsAtom = atom<string[]>({
	key: 'pinnedByInstructorsAtomKey',
	default: [],
});

export const computeVisiblePinners = (
	visibleInstructorIds: string[],
	pinnedBy: string[],
	cap = 8
): string[] => {
	const pinnedSet = new Set(pinnedBy);
	return visibleInstructorIds.filter((id) => pinnedSet.has(id)).slice(0, cap);
};

export const instructorsWhoPinnedMeSelector = selector<string[]>({
	key: 'instructorsWhoPinnedMeSelectorKey',
	get: ({ get }) => {
		const visible = get(filteredInstructorIds('forStudentIds'));
		const pinnedBy = get(pinnedByInstructorsAtom);
		return computeVisiblePinners(visible, pinnedBy);
	},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});
